import GoalsAndOperationalPlansFooter from './GoalsAndOperationalPlansFooter';

export default GoalsAndOperationalPlansFooter;
